package com.eladfinish.bible.contest.screens.randomVerse.ui.dialogs

import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.rememberModalBottomSheetState
import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.screens.randomVerse.RandomVerseAction
import com.eladfinish.bible.contest.screens.randomVerse.RandomVerseState
import com.eladfinish.bible.contest.ui.components.bottomSheet.RichScrollableBottomSheetAnimatedClose

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun RandomVerseChapterPickerSheet(
    bottomSheetState: RandomVerseState.BottomSheetState,
    onAction: (RandomVerseAction) -> Unit,
) {
    val sheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)

    when (bottomSheetState) {
        is RandomVerseState.BottomSheetState.ChapterPicker -> {
            RichScrollableBottomSheetAnimatedClose(
                sheetState = sheetState,
                onHide = {
                    onAction(RandomVerseAction.HideBottomSheet)
                },
                spannable = bottomSheetState.content,
                title = "באיזה פרק הפסוק הזה מופיע?",
            )
        }

        RandomVerseState.BottomSheetState.Hidden -> Unit
    }
}
